import { render, staticRenderFns } from "./OwnUsersList.vue?vue&type=template&id=598837c4&scoped=true&lang=pug"
import script from "./OwnUsersList.vue?vue&type=script&lang=ts"
export * from "./OwnUsersList.vue?vue&type=script&lang=ts"
import style0 from "./OwnUsersList.vue?vue&type=style&index=0&id=598837c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598837c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VChip,VForm,VTextField})
